/**
 * How the product-detail route addresses a product.
 *
 * Products are identified by their ProductV3 key, which IS the AS/400 SKU. That
 * key cannot be a URL path segment: 57,874 of the catalog's keys contain a '/'
 * and 444 contain '%', '?' or '#', so a path segment could only express them as
 * '%2F', which several static hosts normalize or reject on a hard refresh.
 *
 * So the key travels as the `productV3Key` search param and the path segment is
 * this fixed sentinel. Three modules have to agree on it (the route definition,
 * the list page that builds links, and the detail page that reads them), which
 * is why it lives here rather than being spelled out in each.
 */
export const PRODUCT_BY_KEY_SEGMENT = 'by-key';
